import { useLingui } from '@lingui/react/macro';
import { PageContent, PageHeader } from '@web/components/Page';
import PrivateRoute from '@web/components/PrivateRoute';
import { useEntriesApprovalTabs } from '@web/hooks/approvals/useApprovalTabs';
import { Tab, Tabs } from 'carbon-react/lib/components/tabs';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import DashboardContainer from '../DashboardContainer';

const Content = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 58px);
  flex-direction: column;
  div[data-component='tabs'] {
    width: 100%;
  }
`;

const OutletContent = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.palette.slateTint(85)};
  padding: ${({ theme }) => theme.spacing * 3}px;
  padding-top: ${({ theme }) => theme.spacing}px;
  border-radius: ${({ theme }) => theme.spacing / 2}px;
  overflow-x: auto;
`;

export function EntriesApprovalsIndexLayout() {
  const { t } = useLingui();
  const { selectedTabId, handleTabChange } = useEntriesApprovalTabs();

  return (
    <PrivateRoute>
      <DashboardContainer showSecondaryNav>
        <Helmet>
          <title>{t`Approve Time Entries | Sage Intelligent Time`}</title>
        </Helmet>

        <PageContent>
          <PageHeader data-cy="entries-approvals-title" title={t`Approve time entries`} />
          <Content>
            <Tabs onTabChange={handleTabChange} position="top" selectedTabId={selectedTabId}>
              <Tab tabId={'todo'} title={t`To do`} />
              <Tab tabId={'done'} title={t`Done`} />
            </Tabs>
            <OutletContent data-pendo-id="approvals-tab-content">
              <Outlet />
            </OutletContent>
          </Content>
        </PageContent>
      </DashboardContainer>
    </PrivateRoute>
  );
}
